import { render, staticRenderFns } from "./upload-video-pop.vue?vue&type=template&id=4984b951&"
import script from "./upload-video-pop.vue?vue&type=script&lang=js&"
export * from "./upload-video-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4984b951')) {
      api.createRecord('4984b951', component.options)
    } else {
      api.reload('4984b951', component.options)
    }
    module.hot.accept("./upload-video-pop.vue?vue&type=template&id=4984b951&", function () {
      api.rerender('4984b951', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-picture-library/src/components/upload-video-pop.vue"
export default component.exports